import { adminClient, inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import type { auth } from "./better-auth";

export const authClient = createAuthClient({
	plugins: [adminClient(), inferAdditionalFields<typeof auth>()],
});
